import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import anime from "animejs";

//components

//assets
import { vendorLogosList } from "./constant.js";

const Wrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 20px 62px 70px;
  overflow: hidden;


  @media screen and (max-width: 500px) {
    padding: 20px 20px 60px;
  }
`;

const Slider = styled.div``;

const LogoWrapper = styled.div`
  overflow: hidden;
  white-space:nowrap;
`;

const Link = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-inline: 8vh;

  @media screen and (max-width: 500px) {
    margin-inline: 6vh;
  }
`;

const CompanyLogo = styled.img`
  transform: scale(1.4);
`;

function VendorLogos() {
  const animationRef = useRef();
  let isDown;
  let scrollLeft;
  let startX;

  useEffect(() => {
    animationRef.current = anime({
      targets: ".logo_container",
      keyframes: [{ translateX: -1000 }],
      duration: 40000,
      easing: "linear",
      loop: true,
      width:2500
    });
  }, []);

  const mouseEnter = () => {
    isDown = false;
    animationRef.current.pause();
  };

  const mouseLeave = () => {
    isDown = false;
    animationRef.current.play();
  };

  const mouseDown = (e) => {
    const container = document.querySelector(".logo_container");
    isDown = true;
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  };

  const mouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();

    animationRef.current.pause();
    const container = document.querySelector(".logo_container");
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 7;
    container.scrollLeft = scrollLeft - walk;
  };
  return (
    <Wrapper>
      <Slider id="slider">
        <LogoWrapper
          className="logo_container"
          onMouseEnter={mouseEnter}
          onMouseLeave={mouseLeave}
          onMouseDown={mouseDown}
          onMouseMove={mouseMove}
        >
          {vendorLogosList.map((logo) => (
            <Link
              href={logo.link}
              target="_blank"
              rel="noreferrer"
              key={logo.id}
              className="animeContainer"
            >
              <CompanyLogo src={logo.logo} alt={logo.name} loading="lazy" />
            </Link>
          ))}
        </LogoWrapper>
      </Slider>
    </Wrapper>
  );
}

export default VendorLogos;
